// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'java... Remove this comment to see the full error message
import naturalSort from 'javascript-natural-sort';

import Group from 'entities/Group';
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';

import { Backbone$Id } from 'types/typescript/Backbone';

class Groups extends Collection<Group> {
  initialize() {
    this.url = '/classes';
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof Group' is missing the following prope... Remove this comment to see the full error message
    this.model = Group;
  }

  comparator = (a: Group, b: Group): number => {
    return naturalSort(a.getName().toLowerCase(), b.getName().toLowerCase());
  };

  static fetch(): any {
    return apiRequest('/classes', 'GET').then((response) => Groups.fromJSON(response['classes']));
  }

  static fetchArchived() {
    return apiRequest('/classes/archived', 'GET').then((response) =>
      Groups.fromJSON(response['classes'])
    );
  }

  static setGroupsAllowedToStartChat(groups: Groups) {
    return apiRequest('/classes', 'PATCH', {
      classes: Object.keys(groups).map((groupId) => {
        return {
          id: groupId,
          subscriber_initiated_chats: (groups as any)[groupId],
        };
      }),
    }).then((response) => Groups.fromJSON(response['classes']));
  }

  static bulkUpdate(params: any) {
    return apiRequest('/classes', 'PATCH', {
      classes: params,
    }).then((response) => Groups.fromJSON(response['classes']));
  }

  static linkUnassignedToPrimaryOrg() {
    return apiRequest('/classes/link_unassigned_to_primary_org', 'POST');
  }

  static find(teacherId: Backbone$Id) {
    return apiRequest('/classes/find', 'GET', {
      teacher_id: teacherId,
    }).then((response) => Groups.fromJSON(response) as Groups);
  }
}

export default Groups;
